/**
 * LARVIN Editorial Streetwear Theme Logic
 * Handles Cart Drawer, AJAX Cart, Variant Selectors, Modals
 */

window.Larvin = window.Larvin || {};

// ==========================================
// TOAST NOTIFICATIONS
// ==========================================
let toastTimer;
window.Larvin.showToast = function(message) {
  const toast = document.getElementById('toastNotification');
  const label = document.getElementById('toastMessage');
  if (!toast || !label) return;
  label.textContent = message;
  toast.classList.remove('hidden');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => {
    toast.classList.add('hidden');
  }, 3500);
};

// ==========================================
// CART & CART DRAWER
// ==========================================
window.Larvin.openCartDrawer = function() {
  const drawer = document.getElementById('cartDrawer');
  if (drawer) {
    drawer.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
    window.Larvin.refreshCart();
  } else {
    window.location.href = '/cart';
  }
};

window.Larvin.closeCartDrawer = function() {
  const drawer = document.getElementById('cartDrawer');
  if (drawer) {
    drawer.classList.add('hidden');
    document.body.style.overflow = '';
  }
};

window.Larvin.refreshCart = function() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      // Update badge
      const badges = document.querySelectorAll('.cart-count-badge');
      badges.forEach(b => {
        b.textContent = cart.item_count;
      });
      const headerText = document.getElementById('headerBagText');
      if (headerText) {
        headerText.textContent = `BAG (${cart.item_count})`;
      }

      // Update drawer contents if present
      const container = document.getElementById('cartDrawerItems');
      const subtotalEl = document.getElementById('cartDrawerSubtotal');
      if (container) {
        if (cart.item_count === 0) {
          container.innerHTML = `
            <div class="py-16 text-center text-outline">
              <span class="material-symbols-outlined text-5xl mb-2">shopping_bag</span>
              <p class="font-headline-sm text-lg uppercase text-espresso font-bold">Your bag is empty</p>
              <a href="/collections/all" class="mt-4 inline-block px-6 py-2.5 bg-primary text-champagne rounded font-label-lg text-xs uppercase font-bold">Discover Collection</a>
            </div>
          `;
          if (subtotalEl) subtotalEl.textContent = '₹0';
        } else {
          container.innerHTML = cart.items.map((item, index) => `
            <div class="flex gap-4 p-4 border-b border-espresso/10 bg-surface-white rounded">
              <img src="${item.featured_image ? item.featured_image.url : ''}" alt="${item.title}" class="w-20 h-24 object-cover rounded bg-surface-low">
              <div class="flex flex-col justify-between flex-grow">
                <div>
                  <h4 class="font-headline-sm text-sm uppercase text-espresso font-bold line-clamp-1">${item.product_title}</h4>
                  ${item.variant_title ? `<p class="font-body-sm text-xs text-outline">${item.variant_title}</p>` : ''}
                  <span class="font-bold text-espresso text-sm mt-1 block">₹${(item.final_line_price / 100).toLocaleString()}</span>
                </div>
                <div class="flex items-center justify-between mt-2">
                  <div class="flex items-center bg-surface rounded border border-espresso/10 px-1 py-0.5">
                    <button type="button" onclick="window.Larvin.updateCartQty(${index + 1}, ${item.quantity - 1})" class="w-6 h-6 flex items-center justify-center font-bold text-espresso">-</button>
                    <span class="w-6 text-center text-xs font-bold text-espresso">${item.quantity}</span>
                    <button type="button" onclick="window.Larvin.updateCartQty(${index + 1}, ${item.quantity + 1})" class="w-6 h-6 flex items-center justify-center font-bold text-espresso">+</button>
                  </div>
                  <button type="button" onclick="window.Larvin.updateCartQty(${index + 1}, 0)" class="text-xs text-primary font-bold uppercase hover:underline">Remove</button>
                </div>
              </div>
            </div>
          `).join('');

          if (subtotalEl) {
            subtotalEl.textContent = `₹${(cart.total_price / 100).toLocaleString()}`;
          }
        }
      }
    })
    .catch(err => console.error('Cart refresh error:', err));
};

window.Larvin.updateCartQty = function(line, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: line, quantity: quantity })
  })
    .then(res => res.json())
    .then(() => {
      window.Larvin.refreshCart();
      // If we are on the cart page, reload page to reflect updates
      if (window.location.pathname.includes('/cart')) {
        window.location.reload();
      }
    });
};

window.Larvin.quickAddToCart = function(variantId) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(res => res.json())
    .then(item => {
      window.Larvin.showToast(`Added ${item.title} to bag!`);
      window.Larvin.openCartDrawer();
    })
    .catch(err => {
      console.error('Add to cart error:', err);
      window.Larvin.showToast('Item could not be added');
    });
};

// ==========================================
// MODALS & NAVIGATION
// ==========================================
window.Larvin.openSearch = function() {
  const m = document.getElementById('searchModal');
  if (m) {
    m.classList.remove('hidden');
    const input = document.getElementById('modalSearchInput');
    if (input) setTimeout(() => input.focus(), 50);
  }
};

window.Larvin.closeSearch = function() {
  const m = document.getElementById('searchModal');
  if (m) m.classList.add('hidden');
};

window.Larvin.openSizeGuide = function() {
  const m = document.getElementById('sizeGuideModal');
  if (m) m.classList.remove('hidden');
};

window.Larvin.closeSizeGuide = function() {
  const m = document.getElementById('sizeGuideModal');
  if (m) m.classList.add('hidden');
};

window.Larvin.toggleMobileMenu = function() {
  const m = document.getElementById('mobileMenu');
  if (m) m.classList.toggle('hidden');
};

// Keyboard listener for ESC key
window.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    window.Larvin.closeSearch();
    window.Larvin.closeSizeGuide();
    window.Larvin.closeCartDrawer();
    const mm = document.getElementById('mobileMenu');
    if (mm) mm.classList.add('hidden');
  }
});

// Init on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  window.Larvin.refreshCart();
});
